import { useSelector } from 'react-redux'
import { scrollToElement } from 'Utils/Elements'
import cnames from 'classnames'
import CartButtonSubmit from 'Shared/Cart/Components/CartButtonSubmit'
import FontAwesomeIcon from 'Checkout/Components/Shared/FontAwesomeLib'
import Anchor from 'Shared/Anchor/Anchor'

const PaymentButton = ({ classButton }) => {
  const dueNow = useSelector(state => state.cart.pricing.data.dueNow?.display)
  const isCampgroundRequest = useSelector(state => state.campground.isRequest)
  const loading = useSelector(state => state.cart.pricing.loading)
  const paymentProcessing = useSelector(state => state.cart.paymentProcessing)
  const termsOfService = useSelector(state => state.options.externalLinks.termsOfService)
  const classes = {
    button: cnames('fw-bold mb-3', classButton),
    container: cnames('payment-button mb-3', { 'skeleton-loading': loading || !dueNow }),
  }

  return (
    <div className={classes.container}>
      <CartButtonSubmit block={false} className={classes.button} color="theme-primary" dataTest="payment-submit"
                        formId="payment-form" isDisabled={paymentProcessing} loading={paymentProcessing}>
        <FontAwesomeIcon className="me-2" icon="lock" />

        {isCampgroundRequest ? 'Submit Request' : 'Confirm and Pay'}

        {` ${dueNow || ''}`}
      </CartButtonSubmit>

      <div className="accept-terms text-gray-600 text-smaller-1">
        <p className="mb-1 p-0 text-justify">
          By clicking the button above I agree to the
          <Anchor className="text-salmon ms-1" onClick={() => scrollToElement('policy')}>
            cancellation policy
          </Anchor>,

          <Anchor className="text-salmon mx-1" onClick={() => scrollToElement('rules')}>
            rules
          </Anchor> and

          <a className="text-salmon ms-1" href={termsOfService} rel="noreferrer" target="_blank">
            terms of service
          </a>
        </p>

        {isCampgroundRequest && (
          <p className="fw-bold">
            *You will not be charged until reservation is approved by the campground.
          </p>
        )}
      </div>
    </div>
  )
}

export default PaymentButton
